import React, { ReactNode } from 'react';

interface MobileLayoutProps {
    children: ReactNode;
}

export default function MobileLayout({ children }: MobileLayoutProps) {
    return (
        /* On mobile: centered phone-width container, clipped, full dvh */
        /* On desktop: transparent passthrough — admin layout flex handles structure */
        <div className="relative w-full h-[100dvh] max-w-md mx-auto overflow-hidden flex flex-col bg-deep-navy
                        lg:max-w-none lg:mx-0 lg:h-screen lg:overflow-visible lg:bg-transparent">
            <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-b from-electric-blue/10 to-transparent pointer-events-none z-0"></div>
            {children}
        </div>
    );
}
